import DatePickerInput from "components/datePickerInput/DatePickerInput";
import FormLayout from "components/form/FormLayout";
import Input from "components/form/input";
import SelectNew from "components/select/SelectNew";
import Sheet from "components/sheet/Sheet";
import Portal from "elements/Portal";
import { formatDate } from "helpers/Helpers";
import moment from "moment";
// import { formatDate } from "helpers/Helpers";
// import { useAppSelector } from "hooks/redux";
// import useCurrencyFacility from "hooks/useCurrency/useCurrencyFacility";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { IOffer } from "redux/reducers/models/loyalty";

interface IProps {
    open: boolean;
    onCancel: () => void;
    onOk: (offer: Partial<IOffer>) => void;
    offer?: IOffer;
}

interface IState {
    id?: number;
    title: string;
    description: string;
    //TODO: Make the offer type selectable. For now, only amount_spent is used
    type: "amount_spent" | "product_purchased" | "welcome_bonus" | "birthday_bonus";
    active: number;
    amount_spent: string;
    points_earned: string;
    points_expiry_type: "no_expiry" | "expire_after_days" | "end_of_year" | "annual_date";
    points_expiry_days: string;
    points_expiry_date: Date;
    limited_time: number;
    start_date: Date;
    end_date: Date;
    custom: number;
}


export default function LoyaltyProgramOffersModal(props: IProps) {
    const {open, onCancel, onOk, offer} = props;
    const {t} = useTranslation();
    // const {facilityStore} = useAppSelector(store => store);
    // const { getCurrencySymbol } = useCurrencyFacility();
    const [state, setState] = useState<IState>({
        id: null,
        title: "",
        description: "",
        type: "amount_spent",
        active: 1,
        amount_spent: "",
        points_earned: "",
        points_expiry_type: "no_expiry",
        points_expiry_days: "",
        points_expiry_date: new Date(),
        limited_time: 0,
        start_date: null,
        end_date: null,
        custom: 0,
    });

    useEffect(() => {
        if (!open) {
            setState({
                id: null,
                title: "",
                description: "",
                type: "amount_spent",
                active: 1,
                amount_spent: "",
                points_earned: "",
                points_expiry_type: "no_expiry",
                points_expiry_days: "",
                points_expiry_date: new Date(),
                limited_time: 0,
                start_date: new Date(),
                end_date: new Date(),
                custom: 0,
            });
        } else {
            if (offer) {
                setState({
                    ...offer,
                    amount_spent: offer?.amount_spent?.toString(),
                    points_earned: offer?.points_earned?.toString(),
                    points_expiry_days: offer?.points_expiry_days?.toString(),
                    points_expiry_date: offer?.points_expiry_date ? new Date(moment(offer?.points_expiry_date)?.toISOString()) : new Date(),
                    start_date: new Date(offer?.start_date),
                    end_date: new Date(offer?.end_date),
                });
            }
        }
    }, [open]);

    const POINTS_EXPIRY_TYPES = [
        {id: "no_expiry", label: t("No Expiry")},
        {id: "expire_after_days", label: t("Expire After Days")},
        {id: "end_of_year", label: t("Expire End of Year")},
        {id: "annual_date", label: t("Expire Annually on a Specific Date")},
    ];

    function handleInputChange(e: React.ChangeEvent<HTMLInputElement>) {
        const {id, value } = e.target;

        setState(prev => ({...prev, [id]: value}));
    }

    //TODO: Offer start and end date (when the offer begins and is no longer valid).
    // function setStartDate(date: Date) {
    //     if (date) {
    //         setState(prev => ({...prev, start_date: date}));
    //     }
    // }

    // function setEndDate(date: Date) {
    //     if (date) {
    //         setState(prev => ({...prev, end_date: date}));
    //     }
    // }

    return (
        <Portal isMounted={open}>
            <Sheet
            open={open}
            size="small"
            title={t("Online or in-store purchases")}
            supportText={t("Set how customers earn points for purchases")}
            closable
            onCancel={onCancel}
            onOk={() => onOk({
                ...state,
                amount_spent: Math.abs(Number(state?.amount_spent)),
                points_earned: Math.round(Math.abs(Number(state?.points_earned))),
                points_expiry_days: Math.round(Math.abs(Number(state?.points_expiry_days))),
                points_expiry_date: state?.points_expiry_type === "annual_date" ? formatDate(state?.points_expiry_date) : null,
                // start_date: formatDate(state?.start_date),
                // end_date: formatDate(state?.end_date),
                start_date: undefined,
                end_date: undefined,
            })}
            okText={t("Save")}
            overflow
            >
                <FormLayout>
                    <FormLayout.Group>
                        <Input label={t("Title")} placeholder={t("How to earn points")} value={state?.title} onChange={handleInputChange} id="title" maxLength={100} />
                    </FormLayout.Group>
                    <FormLayout.Group>
                        <Input label={t("Description")} placeholder={t("Details")} value={state?.description} onChange={handleInputChange} id="description" maxLength={100}/>
                    </FormLayout.Group>
                    <FormLayout.Group>
                        {/* <Input prefix={getCurrencySymbol(facilityStore?.facility?.default_currency_code ?? "CAD")} label={t("Amount Spent")} placeholder={"0.00"} type="number" value={state?.amount_spent} onChange={handleInputChange} id="amount_spent"/> */}
                        <Input suffix="points" label={t("Points Earned")} placeholder={"0"} type="number" value={state?.points_earned} onChange={handleInputChange} id="points_earned"/>
                    </FormLayout.Group>
                    <FormLayout.Group>
                    <SelectNew
                        id="points_expiry_selector"
                        value={state?.points_expiry_type}
                        onChange={value => setState(prev => ({...prev, points_expiry_type: value, points_expiry_days: ""}))}
                        options={POINTS_EXPIRY_TYPES}
                        label={t("Points Expiry Type")}
                        tooltip={state?.points_expiry_type === "annual_date" ? `${t("Points will expire annually on")} ${moment(state?.points_expiry_date)?.format("MMMM Do")}` : undefined}
                    />
                    {state?.points_expiry_type === "expire_after_days" ? (
                        <Input label={t("Number of Days Until Expiry")} placeholder="10" value={state?.points_expiry_days} onChange={handleInputChange} type="number" id="points_expiry_days" maxLength={100}/>
                    ) : state?.points_expiry_type === "annual_date" ? (
                        <DatePickerInput 
                            startingDate={state?.points_expiry_date} 
                            setStartingDate={(date: Date) => setState(prev => ({...prev, points_expiry_date: date}))}
                            months={1}
                            position="left"
                            label={t("Expiry Date")}
                        />
                    ) : null}
                    </FormLayout.Group>
                    
                </FormLayout>
                
            </Sheet>
        </Portal>
    );
}